export const CHANGE_VENUE_EMAIL= 'CHANGE_VENUE_EMAIL'
export const CHANGE_VENUE_EMAIL_SUCCESS= 'CHANGE_VENUE_EMAIL_SUCCESS'
export const CHANGE_VENUE_EMAIL_ERROR='CHANGE_VENUE_EMAIL_ERROR'

export const ChangeVenueEmail= (data) => ({
    type: CHANGE_VENUE_EMAIL,
    payload: data
})